import gql from "graphql-tag"

export const AllPaymentSchedulesQuery = gql`
query allPaymentSchedules($driverId: ID, $searchTerm: String, $orderBy: [String], $cursor: String, $first:Int!, $filters: [FilterInput]){
    allPaymentSchedules(driverId: $driverId, searchTerm: $searchTerm, orderBy: $orderBy, first: $first, after: $cursor, filters: $filters){
        edges{
            node{            
                id
                amountToCharge
                driver{
                    id
                    firstName
                    lastName
                    balance
                    name
                    dmvLicense
                }
                scheduleDatetime
                maxRetries
                notes
                status
            }
        }
        pageInfo{
            hasNextPage
            endCursor
        }
    }
}`


export const PaymentsStatusesQuery = gql`query PaymentsStatusesQuery{
    optionsList: __type(name:"BillingPaymentScheduleStatusChoices") {
        states: enumValues {
            name
            description
        }
    }
  }`


